// extracted by mini-css-extract-plugin
module.exports = {"wallex__text":"wallex-title-2_wallex__text__wQeJ6"};